module.exports = __webpack_public_path__ + "img/background.ffc96992.jpeg";